import { render, staticRenderFns } from "./CloseAccount.vue?vue&type=template&id=67f131a2&"
import script from "./CloseAccount.vue?vue&type=script&lang=js&"
export * from "./CloseAccount.vue?vue&type=script&lang=js&"
import style0 from "./CloseAccount.vue?vue&type=style&index=0&id=67f131a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports